import { SelectItem } from "@/Models/Other/SelectItem";

export function initOptions<T extends {}>(): T[] {
    return [];
}
export function initOptionsItem<T = SelectItem>(): T[] {
    return [];
}
